import { render, staticRenderFns } from "./CoverTypePage.vue?vue&type=template&id=04542938&scoped=true&"
import script from "./CoverTypePage.vue?vue&type=script&lang=js&"
export * from "./CoverTypePage.vue?vue&type=script&lang=js&"
import style0 from "./CoverTypePage.vue?vue&type=style&index=0&id=04542938&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04542938",
  null
  
)

export default component.exports